module.exports = __webpack_public_path__ + "img/modal-cl-accept.72ec41b2.svg";